/* istanbul ignore file */
import { ISSUE_STATUSES } from '../state/issue.statuses';
import { INSIGHTS_KEYS } from './insights.keys';
import { capitalize } from 'lodash';
import { mapPmProviderToViewer } from 'common/hooks/pm/usePmViewer/usePmViewer.utils';

/* prettier-ignore */
export const mapInsightToDescription = ({insight, pmProvider}) => {
  const pmViewer = mapPmProviderToViewer(pmProvider);
  const issuesText = capitalize(pmViewer.ticket.plural);

  const mapper = {
    [INSIGHTS_KEYS.ISSUES_IN_STATE]: <>{issuesText} stalled in state: <b>{insight?.state || ISSUE_STATUSES[insight?.state_category]?.name || ''}</b></>,
    [INSIGHTS_KEYS.ISSUES_NO_GIT_ACTIVITY]: <>{issuesText} in progress with <b>no git activity</b></>,
    [INSIGHTS_KEYS.ISSUES_CARRIED_OVER_SPRINTS]: <>{issuesText} are <b>carried over</b></>,
    [INSIGHTS_KEYS.CONTEXT_SWITCH]: <>{issuesText} assigned to <b>over-extended</b> developers</>,
    [INSIGHTS_KEYS.ISSUES_NO_BRANCHES]: <>{issuesText} are <b>missing git branch</b> data</>,
    [INSIGHTS_KEYS.ISSUES_NO_ASSIGNEES]: <>{issuesText} are <b>not assigned</b> to a developer</>,
    [INSIGHTS_KEYS.ISSUES_WITH_NO_ESTIMATION]: <>{issuesText} <b>without an estimate</b></>,
  }
  return mapper[insight?.key] || '';
};

export const mapInsightToChipTitle = ({ insight, pmProvider }) => {
  const pmViewer = mapPmProviderToViewer(pmProvider);
  const issuesText = capitalize(pmViewer.ticket.plural);

  return (
    {
      [INSIGHTS_KEYS.ISSUES_NO_GIT_ACTIVITY]: 'no git activity',
      [INSIGHTS_KEYS.ISSUES_CARRIED_OVER_SPRINTS]: 'carried over',
      [INSIGHTS_KEYS.CONTEXT_SWITCH]: `over-extended developers`,
      [INSIGHTS_KEYS.ISSUES_WITH_NO_ESTIMATION]: 'no estimate',
      [INSIGHTS_KEYS.ISSUES_NO_ASSIGNEES]: `unassigned ${issuesText}`,
      [INSIGHTS_KEYS.ISSUES_NO_BRANCHES]: 'missing git branch',
      [INSIGHTS_KEYS.ISSUES_IN_STATE]: `stalled in state: ${
        insight?.state || ISSUE_STATUSES[insight?.state_category]?.name || ''
      }`
    }[insight?.key] || ''
  );
};
